import React from 'react';
import { ModalFooter } from 'snacks-design-system';

interface componentProps {
  children: React.ReactNode;
}

const PIEModalFooter = (props: componentProps) => {
  return <ModalFooter {...props} />;
};

export default PIEModalFooter;
